import {Modal} from 'bootstrap'
import './js/functions'

import './scss/index.scss'

